import { render, staticRenderFns } from "./SessionsSelectbox.vue?vue&type=template&id=35f37d32&"
import script from "./SessionsSelectbox.vue?vue&type=script&lang=js&"
export * from "./SessionsSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports